/**
 * @generated SignedSource<<3a2a9ece4ad24745abb06106bff12626>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CriticalityLevel = "CRITICAL" | "INFO" | "WARNING";
export type DisplayFor = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "NONE" | "NURSING_PROFESSIONAL";
import { FragmentRefs } from "relay-runtime";
export type NewsFragment$data = {
  readonly criticalityLevel: CriticalityLevel;
  readonly displayFor: ReadonlyArray<DisplayFor>;
  readonly endTime: string | null;
  readonly englishContent: string;
  readonly frenchContent: string | null;
  readonly germanContent: string;
  readonly id: string;
  readonly italianContent: string | null;
  readonly startTime: string;
  readonly " $fragmentType": "NewsFragment";
};
export type NewsFragment$key = {
  readonly " $data"?: NewsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "criticalityLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "englishContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "germanContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frenchContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "italianContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayFor",
      "storageKey": null
    }
  ],
  "type": "News",
  "abstractKey": null
};

(node as any).hash = "773619f337a7e8c54a966f947f30d9db";

export default node;
